<template>
  <!-- 链接生成二维码 -->
  <div class="Qr">
    <vue-qr 
      :bgSrc="bgSrc" 
      :logoSrc="logoSrc" 
      :logoScale="20"
      :text="text" 
      :size="size" 
      :margin="0.2"
    ></vue-qr>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import VueQr from 'vue-qr'
export default {
  name:  '',
  components: {
    VueQr
  },
  props: {
    bgSrc: {
      type: String,
      default: ""
    },
    logoSrc: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 120
    },
    backgroundColor: {
      type: String,
      default: "#0B5345 "
    },
    colorDark: {
      type: String,
      default: "#0B5345"
    },
    colorLight: {
      type: String,
      default: "white"
    }
  },
  // 定义属性
  data() {
    return {
      
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {

  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
  
</style>